


import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil
} from "../AllSvg";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast } from "../CustomFunctions";

// ! *************** Sector Crud Models Start ***************



const AddDivision = ({ getDivision }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',
            sub_company: "",
        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        setShow(true);
    };
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const [formData, setFormData] = useState({
        name: '',
        sub_company: "",
    });

    // console.log(formData.Division_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            "sub_company"

            // formData.Division_type === "Monthbywise" ? "month" : null,
            // formData.Division_type === "Monthbywise" ? "year" : null,
            // formData.Division_type === "ProjectbyWise" ? "project" : null,
            // formData.Division_type === "ProjectbyWise" ? "employee" : null,
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.post(
                    `${BASE_URL}/siteproject/divisiongetpost/`,
                    formData
                );

                if (res.status === 200 || res.status === 201) {
                    await getDivision();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Division added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add Division!");

                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
                console.error(err);

            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        // if (name === "Division_type") {
        //     setFormData({
        //         ...FormData,
        //         [name]: newValue,
        //         month: "",
        //         project: "",
        //     });
        // }
        // setFormData({
        //     ...formData,
        //     [name]: newValue,
        // });
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    return (
        <>
            <button
                title="Add Division"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Division
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Add Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Sub Company:<span className="required">*</span>
                                </label>

                                <select
                                    name="sub_company"
                                    value={formData.sub_company}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.sub_company
                                        ? "error"
                                        : inputState.sub_company
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a sub_company</option>
                                    {subcompanyList.map((company) => (
                                        <option value={company.id}>{company.title}</option>
                                    ))}
                                </select>

                                {errors.sub_company && (
                                    <span className="error-message">
                                        {errors.sub_company}
                                    </span>
                                )}
                            </div>


                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateDivision = ({ i, getDivision }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',
            sub_company: "",
        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        setFormData(i);
        setShow(true);
    };
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const [formData, setFormData] = useState({
        name: '',
        sub_company: "",
    });

    // console.log(formData.Division_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            "sub_company"

            // formData.Division_type === "Monthbywise" ? "month" : null,
            // formData.Division_type === "Monthbywise" ? "year" : null,
            // formData.Division_type === "ProjectbyWise" ? "project" : null,
            // formData.Division_type === "ProjectbyWise" ? "employee" : null,
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.put(
                    `${BASE_URL}/siteproject/divisionputdelete/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getDivision();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Division added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add Division!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        // if (name === "Division_type") {
        //     setFormData({
        //         ...FormData,
        //         [name]: newValue,
        //         month: "",
        //         project: "",
        //     });
        // }
        // setFormData({
        //     ...formData,
        //     [name]: newValue,
        // });
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    return (
        <>
            <button
                title="Edit DivisionDetails"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil /> {" "}

            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Update Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Sub Company:<span className="required">*</span>
                                </label>

                                <select
                                    name="sub_company"
                                    value={formData.sub_company}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.sub_company
                                        ? "error"
                                        : inputState.sub_company
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a sub_company</option>
                                    {subcompanyList.map((company) => (
                                        <option value={company.id}>{company.title}</option>
                                    ))}
                                </select>

                                {errors.sub_company && (
                                    <span className="error-message">
                                        {errors.sub_company}
                                    </span>
                                )}
                            </div>


                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Update
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



const DeleteDivision = ({ i, getDivision }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/divisionputdelete/${i.id}/`
            );

            if (res.status === 200) {
                await getDivision();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Division deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Division"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Division of "{i.name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Division ?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const Division = ({ subCompanyId }) => {
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [toggleStatus, setToggleStatus] = useState(subCompanyId || "null");
    const [divisionData, setdivisionData] = useState("null");

    const getDivision = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/siteproject/Divisionfilterbystatus/${toggleStatus}/`;

            const sub = await axios.get(url);

            setdivisionData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };


    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const role = sessionStorage.getItem("role");
    const department = sessionStorage.getItem('department')

    const [projectListData, setProjectList] = useState([]);

    const getDivisonData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/divisionfilter/${toggleStatus}/`
            );
            setdivisionData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getDivisonData();
    }, [toggleStatus]);
    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }

    useEffect(() => {
        getSubCompany()
    }, [])
    return (
        <>



            <div className="table-css-white-background" style={{ padding: "34px 30px" }}>
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        Division
                    </div>
                    <div className="field-cont">
                        <div className="table-searchh dropdown-container field-cont-div">
                            <select
                                onChange={(e) => setToggleStatus(e.target.value)}
                                value={toggleStatus}
                                className="dropdown font-size-subheading  "
                            >
                                {
                                    subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ?
                                        <>  {subcompanyList.filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").map((company) => (
                                            <option value={company.id}>{company.title}</option>
                                        ))}
                                        </> :
                                        <>
                                            {subcompanyList.filter(i => i.id === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").map((company) => (
                                                <option value={company.id}>{company.title}</option>
                                            ))}
                                        </>
                                }


                            </select>
                        </div>

                        <AddDivision
                            getDivision={getDivision}
                            sectorList={divisionData}
                        />
                    </div>
                </div>
                {/* <SectorsDetailForm /> */}
                <div className="table-box height-73vh">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr ">
                                <th className="align-left">Sr.No.</th>
                                <th className="align-center">Name</th>

                                <th className="align-center">Sub Company</th>

                                <th className="align-center width-5vw">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : (
                            <tbody>
                                {divisionData
                                    // ?.filter((e) =>
                                    //     e.status === toggleStatus
                                    // )
                                    // .sort((a, b) =>
                                    //     a.booking_date.localeCompare(b.booking_date, "en", { ignorePunctuation: true })
                                    // )
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="6"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.name}</td>
                                                {/* <td className="align-center ">
                                                        {i.Division_type ? i.Division_type : "-"}
                                                    </td> */}
                                                <td className="align-center form-text-trasformation-uppercase">
                                                    {i.sub_company ? i.subcompany_name : '-'}
                                                </td>



                                                <td className="align-center">

                                                    <div className=" flex-row justify-evenly">
                                                        <UpdateDivision
                                                            i={i}
                                                            getDivision={getDivision}
                                                        />
                                                        <DeleteDivision
                                                            i={i}
                                                            getDivision={getDivision}
                                                        />
                                                    </div>




                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
};

export default Division;
